export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/landing')
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/terms-and-conditions')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/user/dashboard')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/user/login')
  },
  {
    path: '/bind',
    name: 'bind',
    component: () => import('./views/user/bind')
  },
  /* ADMINISTRATION */
  {
    path: '/administration',
    name: 'administration_dashboard',
    component: () => import('./views/administration/dashboard')
  },
  {
    path: '/administration/release',
    name: 'administration_release',
    component: () => import('./views/administration/release')
  },
  {
    path: '/administration/subscriptions',
    name: 'administration_subscriptions',
    component: () => import('./views/administration/subscriptions')
  }
]
